import { Card } from "@/components/shared-ui/Card/styled";
import type { RoadmapItemStatus } from "@/services/api/types";
import styled from "styled-components";
import { getRoadmapStatusDot } from "../statusColors";

export const ItemCard = styled(Card)<{ $clickable?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.9rem;
  font-weight: 500;
  grid-column: span 1;
  height: 100%;
  ${(props) =>
    props.$clickable &&
    `
  &:hover {
    box-shadow: 0px 0px 10px 0px rgb(29, 23, 57, 0.5);
    cursor: pointer;
  }
  `}
`;
export const ItemStatus = styled.div<{ $status?: RoadmapItemStatus }>`
  position: absolute;
  left: -10px;
  top: 14px;
  height: 20px;
  width: 20px;
  border: 4px solid ${(props) => props.theme.colors.lightest};
  border-radius: 10px;
  ${(props) =>
    props.$status &&
    `
    background: ${getRoadmapStatusDot(props.theme, props.$status)};
  `};
`;

export const CardTitleContainer = styled.div<{ isLater?: boolean }>`
  position: relative;
  padding: 0.8rem 2.5rem 0.8rem 1.5rem;
  background: ${(props) =>
    props.isLater ? props.theme.colors.lightest : props.theme.gradients.light2};
  min-height: 72px;
  border-radius: 4px;
  height: 100%;
`;

export const ChangeIcon = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  column-gap: 0.25rem;
`;
